export default {
    install(Vue) {

        Vue.prototype.getComByteLength = function(str) {
            if (str == null || str.length == 0) {
                return 0;
            }
            var size = 0;
            for ( var i = 0; i < str.length; i++) {
                size += this._charByteSize(str.charAt(i));
            }
            return size;
        };
        
        Vue.prototype._charByteSize = function(ch) {
            if (ch == null || ch.length == 0) {
                return 0;
            }
            var charCode = ch.charCodeAt(0);
    
            if (charCode <= 0x00007F) {
                return 1;
            } else if (charCode <= 0x0007FF) {
                return 2;
            } else if (charCode <= 0x00FFFF) {
                return 2;
            } else {
                return 2;
            }
        };
    }
}


// WEBPACK FOOTER //
// ./src/js/store/module/common/byteFunction.js